export default "__VITE_ASSET__CsULLw7y__"